<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-11 10:48:10
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-22 14:53:01
 * @FilePath: \合联\oms\src\view\analysis\tmClosedLoop\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/tmClosedLoop";
export default {
  name: "tmClosedLoop",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        save: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              cause: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { cause: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("运单号"),
              placeholder() {
                return this.$tz("运单号");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            },
            {
              name: this.$tz("闭环,原因"),
              key: "cause",
              component: "Select",
              placeholder: () => this.$tz("闭环,原因"),
              options: [],
              optionsFn: "loopType",
              optionsKey: "",
              default: ""
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "dataType",
            placeholder() {
              return this.$tz("时间类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "LOOP_ORDER_TIME_SELECT"
          },
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "cause",
            placeholder() {
              return this.$tz("闭环,原因");
            },
            component: "Select",
            options: [],
            optionsFn: "loopType",
            optionsKey: ""
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("闭环,状态");
            },
            component: "Select",
            options: [
              {
                label: this.$tz("待确认"),
                value: "1"
              },
              {
                label: this.$tz("已确认"),
                value: "2"
              }
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length === 0;
              }
            },
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary"
              },
              id: 1891
            },
            {
              name: () => this.$tz("批量,确认"),
              type: "confirm",
              fnName: "confirm",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length === 0;
              },
              id: 1890
            },
            {
              name: () => this.$tz("删除"),
              type: "del",
              fnName: "del",
              bind: {
                type: "error"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            del() {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { ids: this.selectAll.map(t => t.id) },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("save").open({}, function() {
                this.setTitle(this.$tz("新增"));
              });
            },
            confirm() {
              this.$Modal.confirm({
                title: this.$tz("批量,确认"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "confirm",
                    { ids: this.selectAll.map(t => t.id) },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("运单号"),
          key: "airway_number",
          minWidth: 130,
          copy: true,
          header: {
            copy: true
          }
        },
        {
          name: () => this.$tz("闭环,原因"),
          key: "cause",
          minWidth: 130
        },
        {
          name: () => this.$tz("是否,作废,原单号"),
          key: "is_cancel",
          minWidth: 130
        },
        {
          name: () => this.$tz("闭环,状态"),
          key: "status",
          minWidth: 130
        },
        {
          name: () => this.$tz("流入时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("订单,创建,时间"),
          key: "order_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("最迟,时间"),
          key: "order_time1",
          minWidth: 110
        },
        {
          name: () => this.$tz("确认人"),
          key: "operate",
          minWidth: 130
        },
        {
          name: () => this.$tz("闭环,时间"),
          key: "operate_time",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
